export class API {
	constructor(src) {
		const url = new URL(src);
		this.source = `https://${url.hostname}/wp-json/`;
	}
	fetch(path, method='GET', args=false) {
		let fetchArgs = {
			method: method
		};
		if (args!==false) {
			fetchArgs.body = JSON.stringify(args);
		}		
		fetchArgs.headers = {
			'Content-Type' : 'application/json',
		}

		let fetchUrl = ``;
		// If we have boardsApiSettings, we're on the live site, so we're fetching from the rest API
		// If we don't have boardsApiSettings, we're on the static site, so we're fetching the
		// json static content from the boards static site.
		if (`undefined`!=typeof boardsApiSettings) {
			fetchArgs.headers['X-WP-Nonce'] = boardsApiSettings.nonce;
			fetchUrl = this.source + path;
		} else {
			fetchUrl = `/` + path + `.js`;
		}

		return fetch(fetchUrl, fetchArgs).then(response=>response.json());
	}
	Boards() {
		return this.fetch(`wp/v2/board`);
	}
	BoardMessagePost(board_id, parent_id, name, email, message) {
		return this.fetch(`boards/v1/board/${board_id}`, `POST`, {
			none:  boardsApiSettings.nonce,
			board_id: board_id,
			parent_id: parent_id,
			name: name,
			email: email,
			message: message
		});
	}
	DeleteMessage(messageId) {
		return this.fetch(`boards/v1/message/${messageId}`, `DELETE`);
	}
	Messages(board_id) {
		return this.fetch(`boards/v1/board/${board_id}`);
	}
}